import Carousel from "nuka-carousel";
import React, {useState} from "react";
import {H2, H3, Paragraph} from "BaseComponents/Text";
import {CardWrapper, ConceptInnerWrapper, ConceptWrapper, ImageWrapper, SliderWrapper,} from "./components";
import useBreakpoint from "Hooks/useBreakpoint";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {GetTextColor} from "Helpers/ColorHelper";
import LazyImage from "../../framework/lazy/LazyImage";
import {CardWrapperDiv} from "./components/CardWrapper";

const CardBody = ({Image, Heading, Preamble, Alt}) => {
  return (<>
    <ImageWrapper>
      <LazyImage source={Image} alt={Alt}/>
    </ImageWrapper>
    <H3 textAlign="center">{Heading}</H3>
    <Paragraph display="block" center>
      {Preamble}
    </Paragraph>
  </>);
}

const CardsToShow = (Concepts) => {
  return Concepts.map((card, index) => {
    const {Link, Heading, Preamble, ResponsiveImage} = card;
    let Image = getResponsiveImage(ResponsiveImage);
    let alt = ResponsiveImage.Alt;
    return (
      <React.Fragment key={`concept-link-card-${index}`}>
        {Link ?
          <CardWrapper href={Link}>
            <CardBody Preamble={Preamble} Heading={Heading} Image={Image} Alt={alt}/>
          </CardWrapper>
          : <CardWrapperDiv>
            <CardBody Preamble={Preamble} Heading={Heading} Image={Image} Alt={alt}/>
          </CardWrapperDiv>
        }
      </React.Fragment>
    );
  });
};

export const Concepts = ({Heading, Concepts, BackgroundColor}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  let notFirstSlide = currentSlide != 0;
  const {textColor} = GetTextColor(BackgroundColor);
  return (
    <ConceptWrapper className={`conceptBlock ${!Heading ? 'withoutHeading' : ''}`} notFirstSlide={notFirstSlide}
                    bgColor={BackgroundColor}>
      <ConceptInnerWrapper className="conceptInnerWrapper">
        {Heading && <H2
          className="conceptHeading"
          color={textColor}
          inline
          margin="0 0 2rem 0"
          marginsmall="0 0 1rem 0"
        >
          {Heading}
        </H2>}
        {Concepts.length > 0 && useBreakpoint("mobile", "down") && (
          <SliderWrapper
            bgColor={BackgroundColor}
            notFirstSlide={currentSlide != 0}
          >
            <Carousel
              renderCenterLeftControls={() => null}
              renderCenterRightControls={() => null}
              heightMode="first"
              slidesToShow={1.2}
              afterSlide={(slideIndex) => setCurrentSlide(slideIndex)}
              scrollMode="page"
              speed={150}
              slideWidth={1}
              easing="easeLinear"
            >
              {CardsToShow(Concepts)}
            </Carousel>
          </SliderWrapper>
        )}
        <SliderWrapper
          justify={Concepts.length > 3 ? "space-between" : "flex-start"}
        >
          {Concepts.length > 0 &&
            useBreakpoint("ipad", "up") &&
            CardsToShow(Concepts)}
        </SliderWrapper>
      </ConceptInnerWrapper>
    </ConceptWrapper>
  );
};
